import React, { useEffect } from "react";
import "./TabelaOcorrenciasDash.css";
import { useProfile } from "../../contexts/ProfileContext.tsx";

function TabelaOcorrenciasDash(props) {
  const { contextoEmbarque } = useProfile();

  const formatarData = (dataString) => {
    const data = new Date(dataString);
    const dia = data.getDate().toString().padStart(2, "0");
    const mes = (data.getMonth() + 1).toString().padStart(2, "0");
    const ano = data.getFullYear();
    return `${dia}/${mes}/${ano}`;
  };

  const colunasFiltradas = props.colunas.filter((coluna) =>
    [
      "dataOcorrencia",
      "observacao",
      "ocorrencia",
      "subTipoOcorrencia",
      "tipoOcorrencia",
    ].includes(coluna.field)
  );

  useEffect(() => {
    if (
      props.dados &&
      props.dados.length > 0 &&
      props.dados[0] &&
      props.dados[0].idEmbarque
    ) {
      const tableWrapper = document.getElementById("tableWrapper");
      if (
        tableWrapper &&
        window.location.href.endsWith("embarque") &&
        contextoEmbarque !== "templateEmbarque"
      ) {
        tableWrapper.scrollTop = tableWrapper.scrollHeight;
      }
    }
  }, []);

  return (
    <div className="outer-wrapper-ocorrencias">
      <div className="table-wrapper-ocorrencias" id="tableWrapper">
        <p style={{ textAlign: "center", marginBottom: 10 }}>
          Dashboard Ocorrências
        </p>
        <table className="tabela-ocorrencias">
          <thead>
            <tr>
              <th
                onClick={() => props.buscarSearch("cte")}
                className="th-ocorrencias"
              >
                CTE
              </th>
              <th
                onClick={() => props.buscarSearch("load")}
                className="th-ocorrencias"
              >
                LOAD
              </th>
              <th
                onClick={() => props.buscarSearch("placaCavalo")}
                className="th-ocorrencias"
              >
                Placa Cavalo
              </th>
              <th
                onClick={() => props.buscarSearch("dataHoraEmbarcado")}
                className="th-ocorrencias"
              >
                Data Viagens
              </th>
              {colunasFiltradas.map((coluna, index) => (
                <th
                  onClick={() => props.buscarSearch(coluna.field)}
                  className="th-ocorrencias"
                  key={index}
                >
                  {coluna.nomeColuna}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {props.dados
              ? props.dados.map((linha, index) => (
                  <>
                    <tr className="tr-hover" key={index}>
                      <td className="td-ocorrencias">
                        {linha.embarqueRetorno.cte}
                      </td>
                      <td className="td-ocorrencias">
                        {linha.embarqueRetorno.load}
                      </td>
                      <td className="td-ocorrencias">
                        {linha.embarqueRetorno.placaCavalo}
                      </td>
                      <td className="td-ocorrencias">
                        {formatarData(
                          linha.embarqueRetorno.dataHoraEmbarcado
                        ) !== "01/01/2000"}
                      </td>
                      {colunasFiltradas.map((coluna) => (
                        <td className="td-ocorrencias" key={coluna.field}>
                          {coluna.field === "dataOcorrencia"
                            ? formatarData(linha[coluna.field])
                            : typeof linha[coluna.field] === "object" &&
                              linha[coluna.field] !== null
                            ? linha[coluna.field].nome ||
                              linha[coluna.field].tipo ||
                              ""
                            : linha[coluna.field]}
                        </td>
                      ))}
                    </tr>
                  </>
                ))
              : null}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default TabelaOcorrenciasDash;
